module.exports = "/_next/static/images/031aaf961233f8248ee5223ccd983731-card-lg.png";